module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/adengiBannerImage-67ef2361b46a95a5dc73fa415ef7f06a.png";